/** @module csi/view/_query/ReportFunctions */
define([
	"c8-numeraljs"
], function({bigAdd, bigDiv, bigTimes}) {

	return {
		/** list of functions that require two keys */
		functionsRequiringSecondKey: ["WEIGHTED_AVG"],

		/** the list of available report functions */
		reportFunctions: ["SUM", "MIN", "MAX", "AVG", "WEIGHTED_AVG"],

		/**
		 * Compute average of given values, both cached and un-cached.
		 * @param {number[]} values - cached values to process
		 * @param {number} [index] - index to access value when given values are containers (arrays, maps, etc.)
		 * @param {number} [unused]
		 * @param {number} [serverValue] - average value of non-cached values
		 * @param {number} [serverCount] - number of non-cached values
		 * @return {number} result of calculation
		 */
		AVG: function(values, index, unused, serverValue, serverCount) {
			var count = 0;
			var total = 0;
			var x;

			for (var i = values.length - 1; i >= 0; --i) {
				x = values[i];

				if ((x != null) && (index != null)) {
					x = x[index];
				}

				if (x != null) {
					total = bigAdd(total, x);
					++count;
				}
			}

			if (serverValue != null) {
				count += serverCount;
				total = bigAdd(total, bigTimes(serverCount, serverValue));
			}

			return count ? (bigDiv(total, count)) : 0;
		},

		/**
		 * Compute minimum value of given values, both cached and un-cached.
		 * @param {number[]} values - cached values to process
		 * @param {number} [index] - index to access value when given values are containers (arrays, maps, etc.)
		 * @param {number} [unused]
		 * @param {number} [serverValue] - minimum value of non-cached values
		 * @param {number} [unused2]
		 * @return {number} result of calculation
		 */
		MIN: function(values, index, unused, serverValue, unused2) {
			var result = Infinity;
			var x;

			for (var i = values.length - 1; i >= 0; --i) {
				x = values[i];

				if ((x != null) && (index != null)) {
					x = x[index];
				}

				if ((x != null) && (x < result)) {
					result = x;
				}
			}

			if ((serverValue != null) && (serverValue < result)) {
				result = serverValue;
			} else if (result == Infinity) {
				return 0;
			}

			return result;
		},

		/**
		 * Compute maximum value of given values, both cached and un-cached.
		 * @param {number[]} values - cached values to process
		 * @param {number} [index] - index to access value when given values are containers (arrays, maps, etc.)
		 * @param {number} [unused]
		 * @param {number} [serverValue] - maximum value of non-cached values
		 * @param {number} [unused2]
		 * @return {number} result of calculation
		 */
		MAX: function(values, index, unused, serverValue, unused2) {
			var result = -Infinity;
			var x;

			for (var i = values.length - 1; i >= 0; --i) {
				x = values[i];

				if ((x != null) && (index != null)) {
					x = x[index];
				}

				if ((x != null) && (x > result)) {
					result = x;
				}
			}

			if ((serverValue != null) && (serverValue > result)) {
				result = serverValue;
			} else if (result == -Infinity) {
				return 0;
			}

			return result;
		},

		/**
		 * Compute sum of given values, both cached and un-cached.
		 * @param {number[]} values - cached values to process
		 * @param {number} [index] - index to access value when given values are containers (arrays, maps, etc.)
		 * @param {number} [unused]
		 * @param {number} [serverValue] - sum of non-cached values
		 * @param {number} [unused2]
		 * @return {number} result of calculation
		 */
		SUM: function(values, index, unused, serverValue, unused2) {
			var total = 0;
			var x;

			for (var i = values.length - 1; i >= 0; --i) {
				x = values[i];

				if ((x != null) && (index != null)) {
					x = x[index];
				}

				total = bigAdd(total, (x || 0));
			}

			if (serverValue != null) {
				total = bigAdd(total, serverValue);
			}

			return total;
		},

		/**
		 * Compute weighted average of given values, both cached and un-cached.
		 * @param {number[]} values - cached values to process
		 * @param {number} [index] - index to access value when given values are containers (arrays, maps, etc.)
		 * @param {number[]} weights - weights for each cached value
		 * @param {number} [serverValue] - weighted average of non-cached values
		 * @param {number} [serverWeight] - weight of non=cached values
		 * @return {number} result of calculation
		 */
		WEIGHTED_AVG: function(values, index, weights, serverValue, serverWeight) {
			var total = 0;
			var totalWeight = 0;
			var w;
			var x;

			for (var i = values.length - 1; i >= 0; --i) {
				w = weights[i];
				x = values[i];

				if ((x != null) && (index != null)) {
					x = x[index];
				}

				if ((x != null) && (w != null)) {
					total = bigAdd(total, bigTimes(w, x));
					totalWeight = bigAdd(totalWeight, w);
				}
			}

			if (serverValue != null) {
				totalWeight = bigAdd(totalWeight, serverWeight);
				total = bigAdd(total, bigTimes(serverWeight, serverValue));
			}

			return totalWeight ? (bigDiv(total, totalWeight)) : 0;
		}
	};
});
